import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface Toast {
  id: number
  type: 'success' | 'error' | 'info'
  message: string
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Toast[]>([])
  let nextId = 1

  const addToast = (type: Toast['type'], message: string, duration = 4000) => {
    const id = nextId++
    toasts.value.push({ id, type, message })
    setTimeout(() => {
      removeToast(id)
    }, duration)
  }

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex((t) => t.id === id)
    if (index !== -1) {
      toasts.value.splice(index, 1)
    }
  }

  const success = (message: string) => addToast('success', message)
  const error = (message: string) => addToast('error', message)
  const info = (message: string) => addToast('info', message)

  // Aliases for compatibility
  const showSuccess = success
  const showError = error
  const showInfo = info
  const remove = removeToast

  return { toasts, success, error, info, removeToast, showSuccess, showError, showInfo, remove }
})
